import L from 'leaflet';
import * as d3 from 'd3';

/**
 * Map renderer using Leaflet with OpenStreetMap tiles
 */
export class MapRenderer {
  constructor(selector, locations) {
    this.selector = selector;
    this.locations = locations;
    this.overlays = {};
  }

  async init() {
    // Initialize Leaflet map centered on Sweden
    this.map = L.map(this.selector.replace('#', ''), {
      center: [62.0, 15.0],  // Center of Sweden
      zoom: 5,
      minZoom: 4,
      maxZoom: 18
    });

    // Add OpenStreetMap tiles
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.map);

    // Create SVG overlay for D3 visualizations
    this.createD3Overlay();
  }

  createD3Overlay() {
    // Get the map pane for overlay
    const mapPane = this.map.getPanes().overlayPane;

    // Create SVG element
    this.svg = d3.select(mapPane)
      .append('svg')
      .attr('class', 'd3-overlay')
      .style('position', 'absolute')
      .style('top', 0)
      .style('left', 0)
      .style('pointer-events', 'none');

    // Create layer groups for heatmaps
    this.heatmapLayer1 = this.svg.append('g').attr('class', 'heatmap-layer-1');
    this.heatmapLayer2 = this.svg.append('g').attr('class', 'heatmap-layer-2');

    // Update overlay on map events
    this.map.on('moveend zoom', () => this.updateOverlay());
    this.updateOverlay();
  }

  updateOverlay() {
    const bounds = this.map.getBounds();
    const topLeft = this.map.latLngToLayerPoint(bounds.getNorthWest());
    const bottomRight = this.map.latLngToLayerPoint(bounds.getSouthEast());

    // Update SVG size and position
    this.svg
      .attr('width', bottomRight.x - topLeft.x)
      .attr('height', bottomRight.y - topLeft.y)
      .style('left', topLeft.x + 'px')
      .style('top', topLeft.y + 'px');

    // Update transform for layers
    const transform = `translate(${-topLeft.x},${-topLeft.y})`;
    this.heatmapLayer1.attr('transform', transform);
    this.heatmapLayer2.attr('transform', transform);

    // Trigger update event for heatmap layers
    if (this.onUpdate) {
      this.onUpdate();
    }
  }

  /**
   * Get layer group for heatmap rendering
   */
  getHeatmapLayer(layerId) {
    return layerId === 'metadata1' ? this.heatmapLayer1 : this.heatmapLayer2;
  }

  /**
   * Convert lat/lon to screen coordinates
   */
  project(lat, lon) {
    const point = this.map.latLngToLayerPoint([lat, lon]);
    return [point.x, point.y];
  }

  /**
   * Focus/zoom on a specific location
   */
  focusOnLocation(location) {
    this.map.flyTo([location.lat, location.lon], 10, {
      duration: 1.5
    });
  }

  /**
   * Set update callback for heatmap redraws
   */
  setUpdateCallback(callback) {
    this.onUpdate = callback;
  }
}
